module.exports = __webpack_public_path__ + "static/1_8g5BQiV6rDe-w8rjH8OkYw-3a56f1a7045be08cf398267bca8afcda.png";